import { Channel } from "../entities";

export class ChannelLogic {
    static initEmptyChannel() : Channel {
        return {
            id: '',
            name: '',
            header: '',
            title: '',
            description: '',
            coupon: 0,
            coupon_url_info: '',
            coupon_url_cashing: '',
            handlepayment_url: '',
            download_url: '',
            company: '',
            success_message: '',
            coupontext: '',
            coupontext_error: '',
            hide_paymentprovider_logos: 0,
            coupontext_input: '',
            header_line1: '',
            header_line2: '',
            reference: ''
        }
    }
}